export type UserRole = 'arac_staff' | 'system_admin' | 'general_user';

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  community?: string;
  isActive: boolean;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AuthResponse {
  user: User;
  token: string;
}

// Define permissions for each role
export const rolePermissions = {
  system_admin: [
    'view_leases',
    'edit_leases',
    'approve_applications',
    'manage_users',
    'view_reports',
    'edit_community_data',
    'manage_system_settings',
    'view_audit_logs',
    'manage_user_roles'
  ],
  arac_staff: [
    'view_leases',
    'edit_leases',
    'approve_applications',
    'view_reports',
    'edit_community_data'
  ],
  general_user: [
    'view_leases',
    'view_reports'
  ]
} as const;

export type Permission = typeof rolePermissions[UserRole][number];